import React from 'react'

/**
 * CardTray — "Add a card" chip row.
 *
 * Currently render-only; card-add mutations on usePrep/useInSession
 * are a follow-up. The tray is visible only when the matching section
 * is editable — callers handle visibility at the section level via
 * the `visible` prop.
 *
 * Props:
 *   kind    'prep' | 'inSession'
 *   visible boolean  — whether to render at all
 */
export function CardTray({ kind, visible }) {
  if (!visible) return null

  // TODO(follow-up): wire card-add mutations from usePrep / useInSession
  // once those mutation paths are confirmed in the hooks. For now the tray
  // is a presentational stub so the section structure is complete.

  return (
    <div className="tray" data-testid={`card-tray-${kind}`} aria-label="Add a card">
      <span className="tray-chip tray-chip--stub">+ Add a card</span>
    </div>
  )
}
